var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVectorBanner = function SvgVectorBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315,
    height: 189,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB008C",
    d: "M.445 108.397C.445 48.799 48.758.497 108.346.497H315S204.191 165.134 184.691 184.654c-19.529 19.548-46.522 31.643-76.335 31.643-59.598 0-107.91-48.312-107.91-107.901"
  })));
};
export default SvgVectorBanner;